// extracted by mini-css-extract-plugin
export default {"About":"About_About__j8lqP","About__header":"About_About__header__86-HE","About__content":"About_About__content__QQGG-"};